import { type ToolEntry, toolEntryNames } from '@zerohuman/shared'

export type ToolChip = { vendor: string; methods: string[] }

/**
 * One chip per vendor (the part before the first dot), keeping the full method names for the
 * chip's title. Shared by TaskDetailView.vue (a cloned task's declared tools) and CatalogView.vue
 * (a public catalog entry's declared tools, before it is cloned -- #410), which both read this
 * off a task version's `tools` list the same way.
 *
 * Each entry is read by the tool name it holds, whatever shape it was stored in (os#1687): a string, or
 * an object naming it by `name`, `toolType` or `type`. One that names no tool has no chip, and the rest
 * still show.
 */
export function groupToolsByVendor(tools: readonly ToolEntry[] | null | undefined): ToolChip[] {
    const chips: ToolChip[] = []
    for (const tool of toolEntryNames(tools ?? [])) {
        const dot = tool.indexOf('.')
        const vendor = dot === -1 ? tool : tool.slice(0, dot)
        const chip = chips.find(row => row.vendor === vendor)
        if (chip) {
            chip.methods.push(tool)
            continue
        }
        chips.push({ vendor, methods: [tool] })
    }
    return chips
}
